import { Col, FormGroup, Label, Row } from "reactstrap";
import CommonFileUpload from "../../../../Utils/CommonComponents/CommonFileUpload";
import { UploadProjectFiles } from "../../../../Utils/Constants";

const UploadProjectFile = () => {
  return (
    <Row>
      <Col>
        <FormGroup>
          <Label check>{UploadProjectFiles}</Label>
          <CommonFileUpload />
        </FormGroup>
      </Col>
    </Row>
  );
};

export default UploadProjectFile;
